/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ArkcrInputs */

const cs_enum_arkcr = /** @type {(inputs: Enum_ArkcrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARK ČR`)
};

const en_enum_arkcr = /** @type {(inputs: Enum_ArkcrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARK ČR`)
};

/**
* | output |
* | --- |
* | "ARK ČR" |
*
* @param {Enum_ArkcrInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_arkcr = /** @type {((inputs?: Enum_ArkcrInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ArkcrInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_arkcr(inputs)
	return cs_enum_arkcr(inputs)
});